module.exports = __webpack_public_path__ + "static/media/tracker_white.919e7a50.png";